// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-install[data-v-7d7aa798]:hover{cursor:pointer}.badge-install[data-v-7d7aa798]{display:flex;margin-left:10px}.badge-install>I[data-v-7d7aa798]{line-height:inherit;margin-right:4px}.badge-install[data-v-7d7aa798]:focus{outline:0}", ""]);
// Exports
module.exports = exports;
